var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Layout',[_c('div',{staticClass:"container mt-4 mb-4"},[_c('div',{staticClass:"mb-2"},[_c('ShowPath',{attrs:{"path":[
          { title: 'Início', to: '/' },
          { title: 'Publicações oficiais', to: '/todos-documentos' },
          { title: _vm.categoriaTitle },
        ]}})],1),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"mb-2"},[_c('Title1',[_vm._v(" "+_vm._s(_vm.categoriaTitle)+" ")])],1)])]),_c('ListDocumentos',{attrs:{"idType":26}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }